import React, { useState, useEffect, useRef } from 'react';
import { Button } from '@/components/ui/button';
import { Check, ChevronDown } from 'lucide-react';
import { sanitizeHtml } from '@/utils/sanitize';

const TextElement = ({ config, onComplete, isCompleted }) => {
  const content = config.content || '';
  const contentRef = useRef(null);
  const [scrolledToBottom, setScrolledToBottom] = useState(false);
  useEffect(() => {
    if (isCompleted || !content) return;
    const container = contentRef.current;
    if (!container) return;
    const checkFit = () => { if (container.scrollHeight <= container.clientHeight + 10) setScrolledToBottom(true); };
    const timer = setTimeout(checkFit, 300);
    const handleScroll = () => { const { scrollTop, scrollHeight, clientHeight } = container; if (scrollTop + clientHeight >= scrollHeight - 20) setScrolledToBottom(true); };
    container.addEventListener('scroll', handleScroll);
    return () => { clearTimeout(timer); container.removeEventListener('scroll', handleScroll); };
  }, [isCompleted, content]);
  return (
    <div className="space-y-4">
      {content ? <div ref={contentRef} className="max-h-[60vh] overflow-y-auto border border-slate-100 rounded-xl p-6" data-testid="text-scroll-container"><div className="prose prose-slate max-w-none cms-content" dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }} /></div> : <p className="text-slate-500 italic">No content configured.</p>}
      {!isCompleted && content && !scrolledToBottom && <p className="text-xs text-slate-500 flex items-center gap-1" data-testid="scroll-hint"><ChevronDown className="h-3 w-3 animate-bounce" /> Scroll to the bottom to continue</p>}
      {!isCompleted && content && <Button onClick={onComplete} disabled={!scrolledToBottom} className={scrolledToBottom ? 'bg-[#20acf6] hover:bg-[#3bb8f7]' : 'bg-slate-300 cursor-not-allowed'} data-testid="mark-read-btn"><Check className="h-4 w-4 mr-2" />{scrolledToBottom ? 'Mark as Read' : 'Read all content to continue'}</Button>}
    </div>
  );
};

export default TextElement;
